import { createAction, createReducer } from '@reduxjs/toolkit'
import { Store } from 'builder/modules/store'
import { BillingStore, Plan, ApiPlan, PaymentMethodsResponse, AdyenConfigResponse } from './types'

// ---
// Action creators
// ---
export const actions = {
  setYearlyOfferPlan: createAction<Plan>('builder/BILLING_SET_YEARLY_OFFER_PLAN'),
  fetchYearlyOfferPlan: createAction('builder/BILLING_FETCH_YEARLY_OFFER_PLAN'),

  fetchAvailablePlans: createAction('builder/BILLING_FETCH_AVAILABLE_PLANS'),
  setAvailablePlans: createAction<ApiPlan[]>('builder/BILLING_SET_AVAILABLE_PLANS'),

  fetchScenario: createAction('builder/BILLING_FETCH_SCENARIO'),
  setScenarioName: createAction<string | null>('builder/BILLING_SET_SCENARIO_NAME'),
  setPlansLoading: createAction<boolean>('builder/BILLING_SET_PLANS_LOADING'),
  setPlansError: createAction<string | null>('builder/BILLING_SET_PLANS_ERROR'),

  fetchPaymentMethods: createAction<{ plan: string }>('builder/BILLING_FETCH_PAYMENT_METHODS'),
  setPaymentMethods: createAction<PaymentMethodsResponse>('builder/BILLING_SET_PAYMENT_METHODS'),
  setPaymentMethodsLoading: createAction<boolean>('builder/BILLING_SET_PAYMENT_METHODS_LOADING'),

  fetchAdyenConfig: createAction('builder/BILLING_FETCH_ADYEN_CONFIG'),
  setAdyenConfig: createAction<AdyenConfigResponse>('builder/BILLING_SET_ADYEN_CONFIG'),
  setAdyenConfigLoading: createAction<boolean>('builder/BILLING_SET_ADYEN_CONFIG_LOADING'),
}

// ---
// Selectors
// ---
export const selectors = {
  yearlyOfferPlan: (state: Store) => state.billingReducer.yearlyOfferPlan,
  availablePlans: (state: Store) => state.billingReducer.availablePlans,
  scenarioName: (state: Store) => state.billingReducer.scenarioName,
  plansLoading: (state: Store) => state.billingReducer.plansLoading,
  plansError: (state: Store) => state.billingReducer.plansError,
  paymentMethods: (state: Store) => state.billingReducer.paymentMethods,
  paymentMethodsLoading: (state: Store) => state.billingReducer.paymentMethodsLoading,
  paymentMethodsHasError: (state: Store) =>
    state.billingReducer.paymentMethods === null && !state.billingReducer.paymentMethodsLoading,
  adyenConfig: (state: Store) => state.billingReducer.adyenConfig,
  adyenConfigLoading: (state: Store) => state.billingReducer.adyenConfigLoading,
  adyenConfigHasError: (state: Store) =>
    state.billingReducer.adyenConfig === null && !state.billingReducer.adyenConfigLoading,
}

// ---
// Reducer
// ---
const initialState: BillingStore = {
  yearlyOfferPlan: null,
  availablePlans: [],
  scenarioName: null,
  plansLoading: false,
  plansError: null,
  paymentMethods: null,
  paymentMethodsLoading: false,
  adyenConfig: null,
  adyenConfigLoading: false,
}

export const reducer = createReducer(initialState, reducer => {
  reducer.addCase(actions.setYearlyOfferPlan, (draft, action) => {
    draft.yearlyOfferPlan = action.payload
  })

  reducer.addCase(actions.setAvailablePlans, (draft, action) => {
    draft.availablePlans = action.payload
  })
  reducer.addCase(actions.setScenarioName, (draft, action) => {
    draft.scenarioName = action.payload
  })
  reducer.addCase(actions.setPlansLoading, (draft, action) => {
    draft.plansLoading = action.payload
  })
  reducer.addCase(actions.setPlansError, (draft, action) => {
    draft.plansError = action.payload
  })

  reducer.addCase(actions.setPaymentMethods, (draft, action) => {
    draft.paymentMethods = action.payload
  })
  reducer.addCase(actions.setPaymentMethodsLoading, (draft, action) => {
    draft.paymentMethodsLoading = action.payload
  })

  reducer.addCase(actions.setAdyenConfig, (draft, action) => {
    draft.adyenConfig = action.payload
  })
  reducer.addCase(actions.setAdyenConfigLoading, (draft, action) => {
    draft.adyenConfigLoading = action.payload
  })
})
